import { Box, Link, Paper, Typography } from '@mui/material'
import React from 'react'
import projectTemplates from '../../data/templates-featured.json'
import { createTheme } from '@mui/material'

const Templates = (props) => {

  const theme = createTheme({
    breakpoints: {
      values: {
        xs: 0,
        sm: 600,
        md: 900,
        lg: 1200,
        xl: 1536,
      },
    },
  });
  

  return (
    <Box sx={{alignItems: "center", display: "flex", justifyContent: "center",}}>
      <Box>
        <Box sx={{display: "flex", flexWrap: "wrap", justifyContent: "center",}}>
          {
            projectTemplates.map(template => (
              <Box
                key={template.name}
                sx={{
                  flexBasis: "25%",
                  [theme.breakpoints.down('md')]: {
                    flexBasis: '50%',
                  },
                  [theme.breakpoints.down('sm')]: {
                    flexBasis: "100%",
                  },
                  p:.5,
                }}
              >
                <Paper>
                  <Link
                    aria-label={template.name}
                    href={template.url}
                  >
                    <Box
                      component="div"
                      loading="lazy"
                      sx={{
                        backgroundImage: process.env.NODE_ENV === "development" ? `url(${template.image})` : `url(${'/wp-content/themes/personal-architect/' + template.image})`,
                        backgroundColor: "#eeeeee",
                        backgroundSize: 'cover',
                        backgroundPositionX: "50%",
                        backgroundPositionY: "50%",
                        borderTopLeftRadius: 4,
                        borderTopRightRadius: 4,
                        height: 200,
                        width: "100%",
                        transition: '.1s ease all',
                        '&:hover': {
                          opacity: .9,
                        },
                      }}
                    />
                  </Link>
                  <Box sx={{p:1.25}}>
                    <Typography component="p" fontWeight={700} fontSize={16} lineHeight={1.5} variant='h6'>{template.name}</Typography>
                    <Typography
                      fontSize={14}
                      color="rgba(0, 0, 0, 0.54)"
                      lineHeight={1.5}
                      sx={{
                        display: '-webkit-box',
                        overflow: 'hidden',
                        WebkitBoxOrient: 'vertical',
                        WebkitLineClamp: 1,
                      }}
                    >{template.description}</Typography>
                  </Box>
                </Paper>
              </Box>
            ))
          }
        </Box>
      </Box>
    </Box>
  )
}

export default Templates